export const getStoredSecret = () => localStorage.getItem('secret')